"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Task = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Task"));

// Generated by script, don't edit it please.
var Task = (0, _createSvgIcon["default"])({
  as: _Task["default"],
  ariaLabel: 'task',
  category: 'application',
  displayName: 'Task'
});
var _default = Task;
exports["default"] = _default;
module.exports = exports.default;